import { useHistory } from "react-router";

import { Button } from "@alpacahq/ui/old";

import type { SessionData } from "~/v2/pages/dashboard/onboarding/session";
import { Path } from "~/v2/path";

interface BackProps {
  session: SessionData;
  patch?: boolean;
  onBeforeBack?: () => void;
}

export const Back = ({ session, patch, onBeforeBack }: BackProps) => {
  const history = useHistory();

  return (
    <Button
      type="button"
      className="mr-auto"
      variant="secondary"
      onClick={() => {
        // call .prev() on the session, pass-through patch
        session
          .prev(patch, onBeforeBack)
          .then(() => {
            session.rerender();
          })
          .catch(
            // if back failed, send to welcome
            () => history.push(Path.ROUTE_NEW_ACCOUNT),
          );
      }}
    >
      Back
    </Button>
  );
};

export default Back;
